import { useI18n } from "../context/I18nContext";
import { Globe } from "lucide-react";

export default function LangSwitcher({ className = "" }) {
  const { lang, setLang } = useI18n();
  return (
    <button
      onClick={() => setLang(lang === "en" ? "ar" : "en")}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md border border-[#E2DBCE] text-xs font-mono-jb uppercase tracking-wider hover:bg-[#F4F0EA] transition-colors ${className}`}
      data-testid="lang-switcher-button"
      aria-label="Switch language"
      title={lang === "en" ? "العربية" : "English"}
    >
      <Globe size={13} />
      {lang === "en" ? "AR" : "EN"}
    </button>
  );
}
